
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { CANDIDATE } from "@/constants/portal.constant";

@Component({
  components: {},
  filters,
})
export default class Features extends Vue {
  private features = [
    {
      image: require("@/assets/icons/landing/icon_cs_feature_jobs.png"),
      label: "Lowongan Kerja",
      subtitle:
        "Temukan lowongan kerja dari berbagai perusahaan di seluruh Indonesia dan lakukan proses lamaran secara digital. Tak ada lagi batasan jarak dalam mencari kerja!",
      url: "dashboard",
      is_redirect: false,
    },
    {
      image: require("@/assets/icons/landing/icon_cs_feature_jobfair.png"),
      label: "Jobfair",
      subtitle: "",
      url: `${CANDIDATE}job-fair`,
      is_redirect: true,
    },
    {
      image: require("@/assets/icons/landing/icon_cs_feature_assessment.png"),
      label: "Tes Assessment",
      subtitle:
        "Lakukan evaluasi diri dan uji kesiapan karir dengan tes-tes khusus. Dapatkan hasil rinci, lengkap dengan saran-saran professional.",
      url: "assesment",
      is_redirect: false,
    },
    {
      image: require("@/assets/icons/landing/icon_cs_feature_profile.png"),
      label: "Profil Karir",
      subtitle:
        "Bangun profil karir yang lengkap dan menonjol untuk menarik perhatian perusahaan dalam proses mencari kerja.",
      url: "profile",
      is_redirect: false,
    },
    {
      image: require("@/assets/icons/landing/icon_cs_feature_event.png"),
      label: "Event & Webinar",
      subtitle:
        "Dapatkan info dan ikuti berbagai acara. Selain acara internal dari sekolah, temukan juga acara eksklusif dari CareerSupport.",
      url: "webinar",
      is_redirect: false,
    },
    {
      image: require("@/assets/icons/landing/icon_cs_feature_elearning.png"),
      label: "E-Learning",
      subtitle:
        "Perluas wawasan di berbagai bidang melalui kelas online CareerSupport. Dari mulai keterampilan dasar sampai tips & trik, selalu ada yang bisa dipelajari.",
      url: "candidate/dashboard",
      is_redirect: false,
    },
  ];
  private selectedFeature = this.features[0];

  private onSelectFeature(data: any) {
    if (data.is_redirect) window.open(data.url, "_blank");
    else this.selectedFeature = data;
  }
}
